import { Ruler } from "lucide-react";
import type { PixatwinSdk } from "@/sdk";

import { MeasurementBottomMenuPanel } from "./MeasurementBottomMenuPanel";
import { MeasurementPlugin } from "./MeasurementPlugin";

export const registerMeasurementPlugin = (sdk: PixatwinSdk): void => {
  sdk.extensions.viewer.register({
    id: "measurement-plugin",
    component: MeasurementPlugin,
  });
  sdk.extensions.bottomMenu.register({
    id: "mesures",
    icon: <Ruler size={24} />,
    label: "Mesures",
    order: 40,
    panel: MeasurementBottomMenuPanel,
  });
};
